export default __webpack_public_path__ + "static/media/no_absences-icon.187973b1.svg";